import { defineComponent as _defineComponent } from 'vue'
import CalculationButton from './CalculationButton.vue';

    interface CounterProps {
        value: number,
        min: number,
        max: number,
        gap?: string,
    }

    interface CounterEmits {
        (e: 'input', value: number): void
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Counter',
  props: {
    value: null,
    min: null,
    max: null,
    gap: { default: 'wide' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'input', value: number): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, min: number, max: number, gap: string }

    

    

    const controlChanged = (counter: number) => {
        let newRange = props.value + counter;
        if (newRange < props.min || newRange > props.max) newRange = props.value;
        emit('input', newRange);
    };

return { __sfc: true,props, emit, controlChanged, CalculationButton }
}

})